import React, { Component } from 'react';
import { connect } from 'react-redux';
import './CloseoutTable.css';
import doneSvg from 'images/done.svg';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import {
  getCloseoutCats,
  getCloseoutContribs,
  getCurrentPage,
  getTotal,
  getPageSize,
} from 'components/admin/projects/details/project-closeout/store/selectors';
import { loadCloseoutContribsRequest } from 'components/admin/projects/details/project-closeout/store/actions';

class CloseoutTable extends Component {
  closeoutContribComments = (closeoutContrib) => {
    const misc = closeoutContrib.closeout_contributor_cats.find(
      (contribCat) => contribCat.closeout_cat.value === 'misc'
    );
    const miscComments = misc && misc.applies && misc.comments;
    return (
      <span>
        {closeoutContrib.comments}
        {miscComments && (
          <span>
            {closeoutContrib.comments && (
              <span>
                <br />
                <br />
              </span>
            )}
            <b>{misc.closeout_cat.label.toUpperCase()}:</b> {miscComments}
          </span>
        )}
      </span>
    );
  };

  mapCloseoutContribs = () => {
    const { closeoutContribs, closeoutCats } = this.props;
    return closeoutContribs.map((closeoutContrib) => {
      return {
        id: closeoutContrib.id,
        data: [
          `${closeoutContrib.csi_code_division} ${
            closeoutContrib.csi_code_label.length > 15
              ? `${closeoutContrib.csi_code_label.substring(0, 15)}...`
              : closeoutContrib.csi_code_label
          }`,
          closeoutContrib.company_name.length > 15
            ? `${closeoutContrib.company_name.substring(0, 15)}...`
            : closeoutContrib.company_name,
        ]
          .concat(
            closeoutCats
              .filter((closeoutCat) => closeoutCat.value !== 'misc')
              .map((closeoutCat) => {
                const closeoutContribCat = closeoutContrib.closeout_contributor_cats.find(
                  (contribCat) => contribCat.closeout_cat_id === closeoutCat.id
                );
                return closeoutContribCat && closeoutContribCat.applies ? (
                  closeoutContribCat.documents.length > 0 ? (
                    <img alt="checked" src={doneSvg} />
                  ) : (
                    ''
                  )
                ) : (
                  'N/A'
                );
              })
          )
          .concat(this.closeoutContribComments(closeoutContrib)),
      };
    });
  };

  handlePageChange = (newPage) => {
    const { currentProject, dispatch } = this.props;
    dispatch(loadCloseoutContribsRequest(currentProject.id, newPage));
  };

  render() {
    const { closeoutCats, currentPage, pageSize, total } = this.props;
    return (
      <div className="closeout-table">
        <SimpleTable
          className="projects-table"
          headers={['CSI CODE', 'SUBCONTRACTOR']
            .concat(
              closeoutCats
                .filter((closeoutCat) => closeoutCat.value !== 'misc')
                .map((cat) => cat.label.toUpperCase())
            )
            .concat('NOTES / COMMENTS')}
          rows={this.mapCloseoutContribs()}
          emptyMessage="No Items"
        />
        <div className="pagination-container">
          <SimplePagination
            currentPage={currentPage}
            pageSize={pageSize}
            total={total}
            onPageChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    closeoutCats: getCloseoutCats(state),
    closeoutContribs: getCloseoutContribs(state),
    currentPage: getCurrentPage(state),
    total: getTotal(state),
    pageSize: getPageSize(state),
  };
})(CloseoutTable);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/CloseoutTable.js